{
  "info": "Informacja",
  "negative": "Błąd",
  "notice": "Ostrzeżenie",
  "positive": "Powodzenie"
}
